import { render, staticRenderFns } from "./AttributeButton.vue?vue&type=template&id=0f24f465&scoped=true&"
import script from "./AttributeButton.vue?vue&type=script&lang=js&"
export * from "./AttributeButton.vue?vue&type=script&lang=js&"
import style0 from "./AttributeButton.vue?vue&type=style&index=0&id=0f24f465&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f24f465",
  null
  
)

export default component.exports